import QuotingServices from "../../services/QuotingServices";
import vm from '@/main.js'
const state = {
    loadingExternal: false,
    externalImage: undefined,
    externalRequestInspection: undefined
};
const getters = {
    externalImage: state => {
        return state.externalImage;
    },
    externalRequestInspection: state => {
        return state.externalRequestInspection;
    },
    loadingExternal: state => {
        return state.loadingExternal;
    }
};

const actions = {
    external(context) {
        context.commit("showLoadingIndicator");        
        const profile = context.rootGetters.userProfile;
        const agencyId= context.rootGetters.agencyId;
        return QuotingServices.external(profile,agencyId)
            .then(response => {
                if (response.data.error == 0) {
                    const item = response.data.data[1];
                    context.commit("loadExternalImage", {item})
                    state.externalRequestInspection = response.data.data[0];
                } else if (response.data.error == 100) {
                    console.log("error df")
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingIndicator");
            });
    },
};

const mutations = {
    showLoadingIndicator(state) {
        state.loadingExternal = true;
    },
    hideLoadingIndicator(state) {
        state.loadingExternal = false;
    },
    loadExternalImage(state, {item}) {
        state.externalImage = item
    }
};

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations
};